/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { getCurrentUser } from 'state/current-user/selectors';
import { Stack } from '@towersystems/towersystems-design-system';
import DetailListItem from 'components/detail-list-item';
import Card from 'components/card';
import DateTime from 'components/date-time';

const PlanDetailsCard = ({ planType, planExpiry, additionalLicenses }) => {
	return (
		<Card>
			<Stack>
				<Card.Section>
					<DetailListItem label='Universal Importer expiry date' detail={<DateTime date={planExpiry} format='Do MMM, YYYY' />} />
				</Card.Section>
			</Stack>
		</Card>
	);
};

export default connect((state) => {
	let user = getCurrentUser(state);
	return {
		planType: user && user.planType,
		additionalLicenses: user && user.additionalLicenses,
		planExpiry: user && user.planExpiry,
	};
}, {})(PlanDetailsCard);
